import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface InitialState {
  openAddVendorDialog: any;
  vendorDetails: any;
  isEditVendor: any;
  openDeleteVendor: any;
}

const initialState: InitialState = {
  openAddVendorDialog: false,
  vendorDetails: {},
  isEditVendor: false,
  openDeleteVendor: false,
};

export const vendorSlice = createSlice({
  name: "vendors",
  initialState,
  reducers: {
    setOpenAddVendorDialog: (state: any, action: PayloadAction<any>) => {
      state.openAddVendorDialog = action.payload;
    },
    setVendorDetails: (state: any, action: PayloadAction<any>) => {
      state.vendorDetails = action.payload;
    },
    setIsEditVendor: (state: any, action: PayloadAction<any>) => {
      state.isEditVendor = action.payload;
    },
    setOpenDeleteVendor: (state: any, action: PayloadAction<any>) => {
      state.openDeleteVendor = action.payload;
    },
  },
});

export const {
  setOpenAddVendorDialog,
  setVendorDetails,
  setIsEditVendor,
  setOpenDeleteVendor,
} = vendorSlice.actions;
